import type { Container, Newable } from "inversify";
import type { IService } from "../Service";
import type { IModule } from "./IModule";

abstract class Module implements IModule {
	abstract moduleName: string;
	abstract api: object;

	#container: Container | null = null;
	public get container(): Container {
		if (this.#container === null) {
			throw new Error("Module must be registered first.");
		}

		return this.#container;
	}

	protected services: Array<Newable<IService>> = [];
	protected getService<T extends IService>(Service: Newable<T>) {
		return this.container.get(Service) as unknown as T;
	}

	protected getTool<T>(Tool: Newable<T>) {
		return this.container.get(Tool) as unknown as T;
	}

	public register(container: Container): void {
		this.#container = container;

		this.services.forEach((x) => {
			container.bind(x).toSelf().inSingletonScope();
		});
	}

	public initialize(): void {
		this.services.forEach((x) => {
			this.getService(x).initialize();
		});
	}

	public dispose(): void {
		[...this.services].reverse().forEach((x) => {
			this.getService(x).dispose();
		});
	}
}

export { Module };
